import React, { useEffect } from 'react';
import { XIcon } from '@heroicons/react/outline';
import { MailIcon } from '@heroicons/react/solid';

const ContactModal = ({ isOpen, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const whatsappNumber = '+22606900473';
    const whatsappMessage = encodeURIComponent('Bonjour, \nJ\'aimerais discuter d\'un projet avec vous.');
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
    // const emailLink = 'mailto:johnlamien@yourstech.fr?subject=Nouveau Projet&body=Bonjour,%0D%0A%0D%0AJe souhaite discuter d\'un projet avec vous.';
    const emailLink = 'mailto:johnlamien@yourstech.fr';

    return (
        <div className='fixed inset-0 z-[100] flex items-center justify-center px-4 animate-fadeIn'>
            {/* Overlay */}
            <div
                className='absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm'
                onClick={onClose}
            ></div>

            {/* Modal */}
            <div className='relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 transform scale-100 opacity-100 transition-all duration-300'>
                {/* Close button */}
                <button
                    onClick={onClose}
                    className='absolute top-6 right-6 p-2 bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-800 transition-all duration-200 border-none'
                >
                    <XIcon className='h-6 w-6' />
                </button>

                {/* Content */}
                <div className='text-center'>
                    {/* Icon */}
                    <div className='mx-auto w-16 h-16 border border-black rounded-full flex items-center justify-center mb-6'>
                        <svg className='w-8 h-8 text-black' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' />
                        </svg>
                    </div>

                    {/* Title */}
                    <h2 className='text-3xl font-bold text-gray-900 mb-3'>
                        Discutons de votre projet
                    </h2>
                    <p className='text-gray-600 mb-8'>
                        Choisissez votre moyen de communication préféré
                    </p>

                    {/* Buttons */}
                    <div className='space-y-4'>
                        {/* WhatsApp Button */}
                        <a
                            href={whatsappLink}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='flex items-center justify-center w-full px-6 py-4 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg font-medium text-lg group'
                        >
                            <svg className='w-6 h-6 mr-3 transition-transform duration-200 group-hover:scale-110' fill='currentColor' viewBox='0 0 24 24'>
                                <path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z' />
                            </svg>
                            WhatsApp
                        </a>

                        {/* Email Button */}
                        <a
                            href={emailLink}
                            className='flex items-center justify-center w-full px-6 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg font-medium text-lg group'
                        >
                            <MailIcon className='w-6 h-6 mr-3 transition-transform duration-200 group-hover:scale-110' />
                            Email
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactModal;